var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      {
        staticClass: "hamburger flex flex-col justify-between",
        on: {
          click: function($event) {
            _vm.open = !_vm.open
          }
        }
      },
      [_c("span"), _vm._v(" "), _c("span"), _vm._v(" "), _c("span")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "top-0 fixed h-[100vh] w-[100vw] bg-orange z-high transition-all ",
        class: { "right-0": _vm.open, "right-[-100vw]": !_vm.open }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "h-[100px] flex items-center justify-between w-full px-24"
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(_vm.svg("liberoo", "fill-white  h-[38px]"))
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "close relative top-[10px] flex flex-col",
                on: {
                  click: function($event) {
                    _vm.open = !_vm.open
                  }
                }
              },
              [
                _c("span", { staticClass: "-rotate-45 absolute top-0 left-0" }),
                _vm._v(" "),
                _c("span", { staticClass: "rotate-45 absolute top-0 left-0" })
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "px-75 pt-75 text-22 flex flex-col gap-8 wrapper justify-center"
          },
          _vm._l(
            _vm.menuItems.filter(function(i) {
              return i.show_in_header
            }),
            function(item) {
              return _c("div", { key: item.id }, [
                _c(
                  "a",
                  {
                    staticClass: "text-white font-medium",
                    attrs: { href: item.relative_url }
                  },
                  [_vm._v(_vm._s(item.title))]
                )
              ])
            }
          ),
          0
        ),
        _vm._v(" "),
        _vm._m(0)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "px-75 pt-24 flex flex-col gap-8 leading-normal text-white font-light text-16"
      },
      [
        _c("a", { attrs: { href: "/scans" } }, [_vm._v("scans")]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/veelgevraagd" } }, [_vm._v("veelgevraagd")]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/liberoo-campus" } }, [
          _vm._v("liberoo campus")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/liberoo-hub" } }, [_vm._v("liberoo hub")])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }